import { createStore, combineReducers } from 'redux';
import WizardReducer from '../components/wizard/container/reducer';
import UrlReducer from './urlReducer';

export const store = createStore(
  combineReducers({
    url: UrlReducer,
    wizard: WizardReducer,
  }),
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);